import { useState } from 'react';

import { Button, Dialog, Field, Input } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { loiTheoTruong } from '../../../lib/errors';
import { useToast } from '../../../lib/toast';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import { useGhiPhien } from '../hooks/useBienBan';
import type { Phien } from '../types';

/** Đổi tên phiên. Phía gọi gắn `key` theo phiên để ô bắt đầu bằng tên hiện tại. */
export function HopDoiTenPhien({ phien, onClose }: { phien: Pick<Phien, 'id' | 'title'> | null; onClose: () => void }) {
  const { t } = useT();
  const toast = useToast();
  const dichLoi = useLoi();
  const { sua } = useGhiPhien();
  const [ten, setTen] = useState(phien?.title ?? '');
  const [daThu, setDaThu] = useState(false);
  const loiTruong = loiTheoTruong(sua.error)['/title'];

  const luu = () => {
    setDaThu(true);
    if (!phien || !ten.trim()) return;
    sua.mutate(
      { id: phien.id, vao: { title: ten.trim() } },
      {
        onSuccess: () => {
          toast.success(t('bienBan.daDoiTen'));
          onClose();
        },
      },
    );
  };

  return (
    <Dialog
      open={Boolean(phien)}
      onClose={onClose}
      title={t('bienBan.hopDoiTen.tieuDe')}
      width={520}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>{t('chung.huy')}</Button>
          <Button variant="primary" size="md" loading={sua.isPending} onClick={luu}>{t('bienBan.hopDoiTen.nut')}</Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <Field
          label={t('bienBan.hopDoiTen.nhan')}
          required
          error={loiTruong ?? (daThu && !ten.trim() ? t('bienBan.hopDoiTen.loiTrong') : undefined)}
        >
          {(p) => <Input {...p} autoFocus value={ten} maxLength={300} onChange={(e) => setTen(e.target.value)} onPressEnter={luu} />}
        </Field>
        {sua.error && !loiTruong && <LoiTrongHop>{dichLoi(sua.error)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
